// extracted by mini-css-extract-plugin
export default {"btn-generate":"GnerateButton_btn-generate__zDbkV","btn-generate-light":"GnerateButton_btn-generate-light__TA9Q5"};